import React, { useState } from 'react';
import TempAuth from './TempAuth';
import { Button, Col, Input, Label, Row } from 'reactstrap';
import { errorToast, successToast } from 'Components/Toasts';
import apiGlobal from 'global/api.global';
import { queryKeyes } from 'shared/queryKeys';
import { encrypt } from 'GenericForms/Helper';
import { queryClient } from 'react-query/queryClient';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import ErrorTooltip from 'Components/ErrorTooltip';

interface ResetPasswordType {
    name: string;
    userID: number;
    setState: (state: boolean) => void;
}

const ResetPassword = ({ name, userID, setState }: ResetPasswordType) => {
    const [authenticated, setAuthenticated] = useState<boolean>(
        !!localStorage.getItem("Authorization_key")
    );
    const [PasswordType, setPasswordType] = useState<'password' | 'text'>('password');
    const key = localStorage.getItem("Authorization_key");

    const validationSchema = Yup.object({
        password: Yup.string()
            .min(6, "Password must be at least 6 characters long")
            .required("Password is required"),
    });

    const handelUpdate = async (password: string) => {
        try {
            const encryptedPassword = encrypt(password);
            const res = await apiGlobal.post(queryKeyes.user.reset_temp_password.url(), {
                password: encryptedPassword,
                user_id: userID,
                authorization_key: key
            });

            if (res.status === 200) {
                successToast("Password updated successfully");
                setState(false);
                queryClient.invalidateQueries(queryKeyes.user.profile.key);
            }
        } catch (err: any) {
            console.error(err);
            errorToast(`${err?.response?.data?.error}`);
        }
    };

    return (
        <div className="p-2">
            {authenticated ? (
                <Formik
                    initialValues={{ password: '' }}
                    validationSchema={validationSchema}
                    onSubmit={(values) => handelUpdate(values.password)}
                >
                    {({ errors, touched }) => (
                        <Form>
                            <Label>Enter new password for {name}</Label>
                            <Col>
                                <Row className="align-items-center d-flex">
                                    <Col>
                                        <Field
                                            as={Input}
                                            type={PasswordType}
                                            name="password"
                                            id="password"
                                            placeholder="Enter new password"
                                        />
                                        {touched.password && errors.password &&
                                            <ErrorTooltip
                                                target="password"
                                                message={errors.password}
                                                open={!!errors.password}
                                            />
                                        }
                                        <i
                                            className={`mdi ${PasswordType === 'password' ? 'mdi-eye' : 'mdi-eye-off'} eye mr-1`}
                                            onClick={() =>
                                                setPasswordType(PasswordType === 'password' ? 'text' : 'password')
                                            }
                                        />
                                    </Col>
                                    <Col xs="auto">
                                        <Button color="primary" size="m" type="submit">
                                            Update
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Form>
                    )}
                </Formik>
            ) : (
                <>
                    <TempAuth setAuthenticated={setAuthenticated} />
                    <Label className="mt-1">
                        <b>[Note]</b> To reset password please authenticate yourself with your password.
                    </Label>
                </>
            )}
        </div>
    );
};

export default ResetPassword;
